export interface IPermissions {
  craneOrderAllowed: boolean
  safetyIssueAllowed: boolean
  cargoUnloadingReportAllowed: boolean
  webCamAllowed: boolean
  vesselCallsAllowed: boolean
  portOperatorRights: boolean
}

export class Permissions implements IPermissions {
  craneOrderAllowed: boolean
  safetyIssueAllowed: boolean
  cargoUnloadingReportAllowed: boolean
  webCamAllowed: boolean
  vesselCallsAllowed: boolean
  portOperatorRights: boolean

  constructor(
    craneOrderAllowed: boolean,
    safetyIssueAllowed: boolean,
    cargoUnloadingReportAllowed: boolean,
    webCamAllowed: boolean,
    vesselCallsAllowed: boolean,
    portOperatorRights: boolean
  ) {
    this.craneOrderAllowed = craneOrderAllowed
    this.safetyIssueAllowed = safetyIssueAllowed
    this.cargoUnloadingReportAllowed = cargoUnloadingReportAllowed
    this.webCamAllowed = webCamAllowed
    this.vesselCallsAllowed = vesselCallsAllowed
    this.portOperatorRights = portOperatorRights
  }
}
